import React, { useCallback, useState } from 'react';
import ConfirmDialog from './ConfirmDialog';

/**
 * Promise-based confirmation, so call sites stay close to the old
 * window.confirm() shape (PRD-1119):
 *
 *   const [confirm, confirmDialog] = useConfirm();
 *   ...
 *   const ok = await confirm({ title, message, variant: 'danger' });
 *   if (!ok) return;
 *   ...
 *   return (<>{confirmDialog}{/* rest of view *\/}</>);
 *
 * Local state only — no Context, per the frontend conventions.
 */
export function useConfirm() {
  const [state, setState] = useState(null);

  const confirm = useCallback(
    (options) =>
      new Promise((resolve) => {
        setState({ options: options || {}, resolve });
      }),
    [],
  );

  const settle = useCallback(
    (result) => {
      setState((current) => {
        if (current?.resolve) current.resolve(result);
        return null;
      });
    },
    [],
  );

  const confirmDialog = state ? (
    <ConfirmDialog
      {...state.options}
      onConfirm={() => settle(true)}
      onCancel={() => settle(false)}
    />
  ) : null;

  return [confirm, confirmDialog];
}

export default useConfirm;
